import { render } from "./VabeneReferralReport.vue?vue&type=template&id=2d1bcb8a&scoped=true&ts=true"
import script from "./VabeneReferralReport.vue?vue&type=script&lang=ts"
export * from "./VabeneReferralReport.vue?vue&type=script&lang=ts"

import "./VabeneReferralReport.vue?vue&type=style&index=0&id=2d1bcb8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1bcb8a"]])

export default __exports__